module.exports = __webpack_public_path__ + "static/ru-2-a1429b9bdef010e222a1c3fbfb26e85a.png";